import { render, staticRenderFns } from "./SortByOption.vue?vue&type=template&id=5b94a428&scoped=true&"
import script from "./SortByOption.vue?vue&type=script&lang=js&"
export * from "./SortByOption.vue?vue&type=script&lang=js&"
import style0 from "./SortByOption.vue?vue&type=style&index=0&id=5b94a428&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b94a428",
  null
  
)

export default component.exports